module.exports = __webpack_public_path__ + "static/media/xroad.3d335f40.svg";